import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgPicpay = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 17" aria-labelledby={titleId} {...props}>
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      d="M13.48 4.117h-1.346v1.345h1.345V4.117zm-7.542.653H4.012v1.687h1.79c1.135 0 1.788.55 1.788 1.584 0 1.033-.653 1.618-1.789 1.618h-1.79V6.491H2.014v7.405h1.999v-2.55h1.896c2.306 0 3.651-1.238 3.651-3.373C9.555 5.974 8.25 4.77 5.938 4.77zm8.886-1.999h-4.03v4.032h4.03V2.77zm-.653 3.34h-2.686V3.425h2.686V6.11z"
    ></path>
  </svg>
);
export default SvgPicpay;
